<!--<div>Layout 1 vertical</div> -->
<!-- SIDE PANEL -->
<ng-container
  *ngIf="
    !fuseConfig.layout.sidepanel.hidden &&
    fuseConfig.layout.sidepanel.position === 'left'
  "
>
  <!-- CHAT PANEL -->
  <!-- <fuse-sidebar name="chatPanel" position="left" class="chat-panel left-chat-panel" [folded]="true" [foldedWidth]="70"
        [foldedAutoTriggerOnHover]="false" lockedOpen="gt-md">
        <chat-panel></chat-panel>
    </fuse-sidebar> -->
  <!-- / CHAT PANEL -->
</ng-container>
<!-- / SIDE PANEL -->

<div id="main">
  <app-top-alerts [alerts]="topAlerts"></app-top-alerts>

  <!-- Rangée sous la barre d'annonces : contenu de l'app à gauche, rail
       d'avatars à droite — la barre d'annonces garde la pleine largeur. -->
  <div class="app-body-row">
    <div class="app-body-main">
      <!-- TOOLBAR: Above -->
      <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      </ng-container>
      <!-- / TOOLBAR: Above -->

      <div id="container-1" class="container">
        <!-- NAVBAR: Left -->
        <ng-container *ngIf="fuseConfig.layout.navbar.position === 'left'">
          <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Left -->

        <div id="container-2" class="container">
          <!-- TOOLBAR: Below fixed -->
          <ng-container
            *ngIf="fuseConfig.layout.toolbar.position === 'below-fixed'"
          >
            <ng-container *ngTemplateOutlet="toolbar"></ng-container>
          </ng-container>
          <!-- / TOOLBAR: Below fixed -->

          <div id="container-3" class="container">
            <!-- TOOLBAR: Below static -->
            <ng-container
              *ngIf="fuseConfig.layout.toolbar.position === 'below-static'"
            >
              <ng-container *ngTemplateOutlet="toolbar"></ng-container>
            </ng-container>
            <!-- / TOOLBAR: Below static -->

            <!-- <ng-progress
          class="ng-progress-bar-container"
          #mainProgressBar
          [color]="'#00FF00'"
          [thick]="true"
          (started)="onProgressBarStarted()"
          (completed)="onProgressBarCompleted()"
        ></ng-progress> -->
            <ng-progress
              ngProgressHttp
              min="20"
              max="1"
              speed="200"
              trickleSpeed="300"
              fadeOutSpeed="50"
              ease="linear"
              relative
              flat
              spinner
              spinnerPosition="right"
            />

            <!-- CONTENT -->
            <content></content>
            <!-- / CONTENT -->

            <!-- FOOTER: Below static -->
            <ng-container
              *ngIf="fuseConfig.layout.footer.position === 'below-static'"
            >
              <ng-container *ngTemplateOutlet="footer"></ng-container>
            </ng-container>
            <!-- / FOOTER: Below static -->
          </div>

          <!-- FOOTER: Below fixed -->
          <ng-container
            *ngIf="fuseConfig.layout.footer.position === 'below-fixed'"
          >
            <ng-container *ngTemplateOutlet="footer"></ng-container>
          </ng-container>
          <!-- / FOOTER: Below fixed -->
        </div>

        <!-- NAVBAR: Right -->
        <ng-container *ngIf="fuseConfig.layout.navbar.position === 'right'">
          <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Right -->
      </div>

      <!-- FOOTER: Above -->
      <ng-container *ngIf="fuseConfig.layout.footer.position === 'above'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </ng-container>
      <!-- FOOTER: Above -->
    </div>

    <!-- CHAT RAIL — barre verticale d'avatars à droite, GOD uniquement -->
    <ng-container
      *ngIf="
        !fuseConfig.layout.sidepanel.hidden &&
        fuseConfig.layout.sidepanel.position === 'right'
      "
    >
      <div class="chat-panel-rail" *ngxPermissionsOnly="['GOD']">
        <chat-panel></chat-panel>
      </div>
    </ng-container>
    <!-- / CHAT RAIL -->
  </div>
</div>

<!-- SELECT CLIENT PANEL (placed first so the create-* panels render above it) -->
<fuse-sidebar
  name="selectClientPanel"
  position="right"
  class="select-client-panel"
>
  <app-select-client
    *ngIf="selectClientPanelService.isOpen$ | async"
  ></app-select-client>
</fuse-sidebar>
<!-- / SELECT CLIENT PANEL -->

<!-- QUICK ORDER PANEL (Commande rapide / Nouvelle Cueillette) -->
<fuse-sidebar name="quickOrderPanel" position="right" class="quick-order-panel">
  <app-quick-order
    *ngIf="quickOrderPanelService.isOpen$ | async"
  ></app-quick-order>
</fuse-sidebar>
<!-- / QUICK ORDER PANEL -->

<!-- CONVERT SUBMISSION PANEL (Soumission web → Proposition / Commande) -->
<fuse-sidebar
  name="convertSubmissionPanel"
  position="right"
  class="convert-submission-panel"
>
  <app-convert-submission
    *ngIf="convertSubmissionPanelService.isOpen$ | async"
  ></app-convert-submission>
</fuse-sidebar>
<!-- / CONVERT SUBMISSION PANEL -->

<!-- CHAT SIDE PANEL (GOD) — contenu de la page /chat en panneau latéral -->
<fuse-sidebar
  *ngxPermissionsOnly="['GOD']"
  name="chatSidePanel"
  position="right"
  class="chat-side-panel"
>
  <chat *ngIf="chatSidePanelService.isOpen$ | async"></chat>
</fuse-sidebar>
<!-- / CHAT SIDE PANEL -->

<!-- CREATE CLIENT & ENTERPRISE PANEL -->
<!-- Mounted OUTSIDE #main so its z-index stacks against CDK overlay (1000) at body level -->
<fuse-sidebar
  name="createClientEnterprisePanel"
  position="right"
  class="create-client-enterprise-panel"
>
  <app-create-client-enterprise-with-details
    *ngIf="createClientEnterprisePanelService.isOpen$ | async"
  ></app-create-client-enterprise-with-details>
</fuse-sidebar>
<!-- / CREATE CLIENT & ENTERPRISE PANEL -->

<!-- CREATE ENTERPRISE PANEL -->
<fuse-sidebar
  name="createEnterprisePanel"
  position="right"
  class="create-enterprise-panel"
>
  <app-create-enterprise-with-details
    *ngIf="createEnterprisePanelService.isOpen$ | async"
  ></app-create-enterprise-with-details>
</fuse-sidebar>
<!-- / CREATE ENTERPRISE PANEL -->

<!-- CREATE CLIENT PANEL -->
<fuse-sidebar
  name="createClientPanel"
  position="right"
  class="create-client-panel"
>
  <app-create-client-with-details
    *ngIf="createClientPanelService.isOpen$ | async"
  ></app-create-client-with-details>
</fuse-sidebar>
<!-- / CREATE CLIENT PANEL -->

<!-- CREATE DELIVERY REQUEST PANEL -->
<fuse-sidebar
  name="createDeliveryRequestPanel"
  position="right"
  class="create-delivery-request-panel"
>
  <app-create-delivery-request
    *ngIf="createDeliveryRequestPanelService.isOpen$ | async"
  ></app-create-delivery-request>
</fuse-sidebar>
<!-- / CREATE DELIVERY REQUEST PANEL -->

<!-- CREATE FLOW PANEL -->
<fuse-sidebar name="createFlowPanel" position="right" class="create-flow-panel">
  <app-create-flow
    *ngIf="createFlowPanelService.isOpen$ | async"
  ></app-create-flow>
</fuse-sidebar>
<!-- / CREATE FLOW PANEL -->

<!-- CREATE PROGRAM PANEL -->
<fuse-sidebar
  name="createProgramPanel"
  position="right"
  class="create-program-panel"
>
  <app-create-program
    *ngIf="createProgramPanelService.isOpen$ | async"
  ></app-create-program>
</fuse-sidebar>
<!-- / CREATE PROGRAM PANEL -->

<!-- SELECT INTERNAL ROOM PANEL (opens above Program) -->
<fuse-sidebar
  name="selectInternalRoomPanel"
  position="right"
  class="select-internal-room-panel"
>
  <app-select-internal-room
    *ngIf="selectInternalRoomPanelService.isOpen$ | async"
  ></app-select-internal-room>
</fuse-sidebar>
<!-- / SELECT INTERNAL ROOM PANEL -->

<!-- CREATE GUEST PANEL -->
<fuse-sidebar
  name="createGuestPanel"
  position="right"
  class="create-guest-panel"
>
  <app-create-guest
    *ngIf="createGuestPanelService.isOpen$ | async"
  ></app-create-guest>
</fuse-sidebar>
<!-- / CREATE GUEST PANEL -->

<!-- CREATE DEPOSIT REQUEST PANEL -->
<fuse-sidebar
  name="createDepositRequestPanel"
  position="right"
  class="create-deposit-request-panel"
>
  <app-create-deposit-request
    *ngIf="createDepositRequestPanelService.isOpen$ | async"
  ></app-create-deposit-request>
</fuse-sidebar>
<!-- / CREATE DEPOSIT REQUEST PANEL -->

<!-- CREATE DEPOSIT IN (CASHING) PANEL -->
<fuse-sidebar
  name="createDepositInPanel"
  position="right"
  class="create-deposit-in-panel"
>
  <app-create-deposit-in
    *ngIf="createDepositInPanelService.isOpen$ | async"
  ></app-create-deposit-in>
</fuse-sidebar>
<!-- / CREATE DEPOSIT IN PANEL -->

<!-- CONGRESS GROUP (Groupe/Entreprise) DEPOSIT REQUEST PANEL -->
<fuse-sidebar
  name="createGroupDepositRequestPanel"
  position="right"
  class="create-deposit-request-panel"
>
  <app-create-group-deposit-request
    *ngIf="createGroupDepositRequestPanelService.isOpen$ | async"
  ></app-create-group-deposit-request>
</fuse-sidebar>
<!-- / CONGRESS GROUP DEPOSIT REQUEST PANEL -->

<!-- CONGRESS GROUP (Groupe/Entreprise) CASHING PANEL -->
<fuse-sidebar
  name="createGroupCashingPanel"
  position="right"
  class="create-deposit-in-panel"
>
  <app-create-group-cashing
    *ngIf="createGroupCashingPanelService.isOpen$ | async"
  ></app-create-group-cashing>
</fuse-sidebar>
<!-- / CONGRESS GROUP CASHING PANEL -->

<!-- ENTERPRISE MULTI CASHING PANEL -->
<fuse-sidebar
  name="enterpriseCashingPanel"
  position="right"
  class="enterprise-cashing-panel"
>
  <app-enterprise-cashing-modal
    *ngIf="enterpriseCashingPanelService.isOpen$ | async"
  ></app-enterprise-cashing-modal>
</fuse-sidebar>
<!-- / ENTERPRISE MULTI CASHING PANEL -->

<!-- CLIENT ATTACH ENTERPRISE PANEL -->
<fuse-sidebar
  name="clientAttachEnterprisePanel"
  position="right"
  class="client-attach-enterprise-panel"
>
  <app-client-attach-enterprise-table-paginated
    *ngIf="clientAttachEnterprisePanelService.isOpen$ | async"
  ></app-client-attach-enterprise-table-paginated>
</fuse-sidebar>
<!-- / CLIENT ATTACH ENTERPRISE PANEL -->

<!-- ADD LABOUR CHARGE (STAFF) PANEL -->
<fuse-sidebar
  name="addLabourChargePanel"
  position="right"
  class="add-labour-charge-panel"
>
  <app-create-labour-charge
    *ngIf="addLabourChargePanelService.isOpen$ | async"
  ></app-create-labour-charge>
</fuse-sidebar>
<!-- / ADD LABOUR CHARGE PANEL -->

<!-- EDIT LABOUR CHARGE (STAFF) PANEL -->
<fuse-sidebar
  name="editLabourChargePanel"
  position="right"
  class="edit-labour-charge-panel"
>
  <app-create-labour-charge
    *ngIf="editLabourChargePanelService.isOpen$ | async"
  ></app-create-labour-charge>
</fuse-sidebar>
<!-- / EDIT LABOUR CHARGE PANEL -->

<!-- ADD SERVICE CHARGE PANEL -->
<fuse-sidebar
  name="addServiceChargePanel"
  position="right"
  class="add-service-charge-panel"
>
  <app-add-service-charge
    *ngIf="addServiceChargePanelService.isOpen$ | async"
  ></app-add-service-charge>
</fuse-sidebar>
<!-- / ADD SERVICE CHARGE PANEL -->

<!-- EDIT SERVICE CHARGE PANEL -->
<fuse-sidebar
  name="editServiceChargePanel"
  position="right"
  class="edit-service-charge-panel"
>
  <app-add-service-charge
    *ngIf="editServiceChargePanelService.isOpen$ | async"
  ></app-add-service-charge>
</fuse-sidebar>
<!-- / EDIT SERVICE CHARGE PANEL -->

<!-- ADD SPECIFIC CONDITION PANEL -->
<fuse-sidebar
  name="addSpecificConditionPanel"
  position="right"
  class="add-specific-condition-panel"
>
  <app-add-specific-condition
    *ngIf="addSpecificConditionPanelService.isOpen$ | async"
  ></app-add-specific-condition>
</fuse-sidebar>
<!-- / ADD SPECIFIC CONDITION PANEL -->

<!-- ADD PRODUCT PANEL -->
<fuse-sidebar name="addProductPanel" position="right" class="add-product-panel">
  <app-order-product-dnd
    *ngIf="addProductPanelService.isOpen$ | async"
  ></app-order-product-dnd>
</fuse-sidebar>
<!-- / ADD PRODUCT PANEL -->

<!-- UPSALE PANEL (upsell interne) -->
<fuse-sidebar name="upsalePanel" position="right" class="upsale-panel">
  <app-order-upsale-panel
    *ngIf="upsalePanelService.isOpen$ | async"
  ></app-order-upsale-panel>
</fuse-sidebar>
<!-- / UPSALE PANEL -->

<!-- UPSALE QUESTIONS PANEL (page produit) -->
<fuse-sidebar
  name="upsaleQuestionsPanel"
  position="right"
  class="upsale-questions-panel"
>
  <app-upsale-questions-panel
    *ngIf="upsaleQuestionsPanelService.isOpen$ | async"
  ></app-upsale-questions-panel>
</fuse-sidebar>
<!-- / UPSALE QUESTIONS PANEL -->

<!-- PRODUCT UPSELL PANEL (fiche produit — suggestions CEL 1-à-N) -->
<fuse-sidebar
  name="productUpsellPanel"
  position="right"
  class="product-upsell-panel"
>
  <app-product-upsell-panel
    *ngIf="productUpsellPanelService.isOpen$ | async"
  ></app-product-upsell-panel>
</fuse-sidebar>
<!-- / PRODUCT UPSELL PANEL -->

<!-- PHOTO LIBRARY PANEL (box Photo Produit/Matériel — sélecteur bibliothèque) -->
<fuse-sidebar
  name="photoLibraryPanel"
  position="right"
  class="photo-library-panel"
>
  <app-photo-library-panel
    *ngIf="photoLibraryPanelService.isOpen$ | async"
  ></app-photo-library-panel>
</fuse-sidebar>
<!-- / PHOTO LIBRARY PANEL -->

<!-- EDIT PRODUCT PANEL -->
<fuse-sidebar
  name="editProductPanel"
  position="right"
  class="edit-product-panel"
>
  <app-edit-product
    *ngIf="editProductPanelService.isOpen$ | async"
  ></app-edit-product>
</fuse-sidebar>
<!-- / EDIT PRODUCT PANEL -->

<!-- ADD MATERIAL PANEL -->
<fuse-sidebar
  name="addMaterialPanel"
  position="right"
  class="add-material-panel"
>
  <app-order-material-dnd
    *ngIf="addMaterialPanelService.isOpen$ | async"
  ></app-order-material-dnd>
</fuse-sidebar>
<!-- / ADD MATERIAL PANEL -->

<!-- EDIT MATERIAL PANEL -->
<fuse-sidebar
  name="editMaterialPanel"
  position="right"
  class="edit-material-panel"
>
  <app-edit-material
    *ngIf="editMaterialPanelService.isOpen$ | async"
  ></app-edit-material>
</fuse-sidebar>
<!-- / EDIT MATERIAL PANEL -->

<!-- EDIT MATERIAL COMBO PANEL (ensemble) -->
<fuse-sidebar
  name="editMaterialComboPanel"
  position="right"
  class="edit-material-combo-panel"
>
  <app-edit-material-combo-panel
    *ngIf="editMaterialComboPanelService.isOpen$ | async"
  ></app-edit-material-combo-panel>
</fuse-sidebar>
<!-- / EDIT MATERIAL COMBO PANEL -->

<!-- EDIT COMBO PANEL (combo produit) -->
<fuse-sidebar name="editComboPanel" position="right" class="edit-combo-panel">
  <app-edit-combo-panel
    *ngIf="editComboPanelService.isOpen$ | async"
  ></app-edit-combo-panel>
</fuse-sidebar>
<!-- / EDIT COMBO PANEL -->

<!-- AUTOMATION PANEL -->
<fuse-sidebar name="automationPanel" position="right" class="automation-panel">
  <app-automation-dialog
    *ngIf="automationPanelService.isOpen$ | async"
  ></app-automation-dialog>
</fuse-sidebar>
<!-- / AUTOMATION PANEL -->

<!-- SENT EMAIL PANEL (historique des courriels — détail d'un courriel) -->
<fuse-sidebar name="sentEmailPanel" position="right" class="sent-email-panel">
  <app-sent-email-detail
    *ngIf="sentEmailPanelService.isOpen$ | async"
  ></app-sent-email-detail>
</fuse-sidebar>
<!-- / SENT EMAIL PANEL -->

<!-- UPGRADE PANEL (mise à niveau / paywall [PRO]) -->
<fuse-sidebar name="upgradePanel" position="right" class="upgrade-panel">
  <app-upgrade-panel
    *ngIf="upgradePanelService.isOpen$ | async"
  ></app-upgrade-panel>
</fuse-sidebar>
<!-- / UPGRADE PANEL -->

<!-- BELL PANEL (centre de notifications — cloche de la barre du haut, tous les forfaits) -->
<fuse-sidebar name="bellPanel" position="right" class="bell-panel">
  <app-bell-panel *ngIf="bellPanelService.isOpen$ | async"></app-bell-panel>
</fuse-sidebar>
<!-- / BELL PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  <toolbar
    *ngIf="!fuseConfig.layout.toolbar.hidden"
    [ngClass]="
      fuseConfig.layout.toolbar.customBackgroundColor === true
        ? fuseConfig.layout.toolbar.position +
          ' ' +
          fuseConfig.layout.toolbar.background
        : fuseConfig.layout.toolbar.position
    "
  >
  </toolbar>
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  <footer
    *ngIf="!fuseConfig.layout.footer.hidden"
    [ngClass]="
      fuseConfig.layout.footer.customBackgroundColor === true
        ? fuseConfig.layout.footer.position +
          ' ' +
          fuseConfig.layout.footer.background
        : fuseConfig.layout.footer.position
    "
  ></footer>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  <fuse-sidebar
    name="navbar"
    class="navbar-fuse-sidebar"
    [folded]="foldedValue"
    lockedOpen="gt-md"
    *ngIf="!fuseConfig.layout.navbar.hidden"
  >
    <navbar
      [variant]="fuseConfig.layout.navbar.variant"
      class="left-navbar"
    ></navbar>
  </fuse-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  <fuse-sidebar
    name="navbar"
    position="right"
    class="navbar-fuse-sidebar"
    [folded]="fuseConfig.layout.navbar.folded"
    lockedOpen="gt-md"
    *ngIf="!fuseConfig.layout.navbar.hidden"
  >
    <navbar
      [variant]="fuseConfig.layout.navbar.variant"
      class="right-navbar"
    ></navbar>
  </fuse-sidebar>
</ng-template>
<!-- / RIGHT NAVBAR -->
